module.exports = __webpack_public_path__ + "media/images/application/avatar-404608525fd7e8d9bad7ccda5abfe898.svg";